import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-customer-privacy',
  standalone: true,
  imports: [],
  templateUrl: './customer-privacy.component.html',
  styleUrl: './customer-privacy.component.scss'
})
export class CustomerPrivacyComponent {
  constructor(private _title: Title) { }

  ngOnInit(): void {
    this._title.setTitle("Privacy Policy");
  }
}
